/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    // IQueryResultSettings,
    // @ts-ignore -- Unused import
    NullResult
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore -- Unused import
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
// @ts-ignore -- Unused import
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './DataServiceEntities.g';

function pahcGetPriceListByCustomerQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function pahcGetPriceListByCustomerInput(customerAccount: string): IDataServiceRequest {
    const query = pahcGetPriceListByCustomerQuery();
    return query.createDataServiceRequestForOperation(
        'PahcGetPriceListByCustomer',
        true,
        DataServiceEntities.PahcPriceListHeaderEntityExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IPahcPriceListHeaderEntity' },
        {
            customerAccount: customerAccount
        }
    );
}

export function pahcGetPriceListByCustomerAsync(
    context: IContext,
    customerAccount: string
): AsyncResult<DataServiceEntities.IPahcPriceListHeaderEntity> {
    const request = pahcGetPriceListByCustomerInput(customerAccount);
    return callActionOrExecute<DataServiceEntities.IPahcPriceListHeaderEntity>(request, context.callerContext);
}

function pahcRequestSalesOrderCancellationQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function pahcRequestSalesOrderCancellationInput(
    cancellationRequest: DataServiceEntities.IPahcSalesOrderCancellationRequestEntity
): IDataServiceRequest {
    const query = pahcRequestSalesOrderCancellationQuery();
    return query.createDataServiceRequestForOperation(
        'PahcRequestSalesOrderCancellation',
        true,
        DataServiceEntities.PahcSalesOrderCancellationResponseEntityExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IPahcSalesOrderCancellationResponseEntity' },
        {
            cancellationRequest: cancellationRequest
        }
    );
}

export function pahcRequestSalesOrderCancellationAsync(
    context: IContext,
    cancellationRequest: DataServiceEntities.IPahcSalesOrderCancellationRequestEntity
): AsyncResult<DataServiceEntities.IPahcSalesOrderCancellationResponseEntity> {
    const request = pahcRequestSalesOrderCancellationInput(cancellationRequest);
    return callActionOrExecute<DataServiceEntities.IPahcSalesOrderCancellationResponseEntity>(request, context.callerContext);
}

function pahcAddItemToExistingSalesOrderQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function pahcAddItemToExistingSalesOrderInput(
    addItemToExistingSalesOrder: DataServiceEntities.IPahcSalesOrderAddProductRequestEntity
): IDataServiceRequest {
    const query = pahcAddItemToExistingSalesOrderQuery();
    return query.createDataServiceRequestForOperation(
        'PahcAddItemToExistingSalesOrder',
        true,
        DataServiceEntities.PahcAddProductToExistingSalesOrderResponseEntityExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IPahcAddProductToExistingSalesOrderResponseEntity' },
        {
            addItemToExistingSalesOrder: addItemToExistingSalesOrder
        }
    );
}

export function pahcAddItemToExistingSalesOrderAsync(
    context: IContext,
    addItemToExistingSalesOrder: DataServiceEntities.IPahcSalesOrderAddProductRequestEntity
): AsyncResult<DataServiceEntities.IPahcAddProductToExistingSalesOrderResponseEntity> {
    const request = pahcAddItemToExistingSalesOrderInput(addItemToExistingSalesOrder);
    return callActionOrExecute<DataServiceEntities.IPahcAddProductToExistingSalesOrderResponseEntity>(request, context.callerContext);
}

function pahcSearchSalesOrderByJDENumberQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function pahcSearchSalesOrderByJDENumberInput(
    searchSalesOrderRequest: DataServiceEntities.IPahcSearchSalesOrderRequestEntity
): IDataServiceRequest {
    const query = pahcSearchSalesOrderByJDENumberQuery();
    return query.createDataServiceRequestForOperation(
        'PahcSearchSalesOrderByJDENumber',
        true,
        DataServiceEntities.PahcSearchSalesOrderResponseEntityExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IPahcSearchSalesOrderResponseEntity' },
        {
            searchSalesOrderRequest: searchSalesOrderRequest
        }
    );
}

export function pahcSearchSalesOrderByJDENumberAsync(
    context: IContext,
    searchSalesOrderRequest: DataServiceEntities.IPahcSearchSalesOrderRequestEntity
): AsyncResult<DataServiceEntities.IPahcSearchSalesOrderResponseEntity> {
    const request = pahcSearchSalesOrderByJDENumberInput(searchSalesOrderRequest);
    return callActionOrExecute<DataServiceEntities.IPahcSearchSalesOrderResponseEntity>(request, context.callerContext);
}
